<template>
  <div>
    <div class="row" v-if="crudCurrentPageTitle === 'location'">
      <div
        class="col-md-12 fme_no-padding"
        style="background-color: ececec; height: 725px; overflow: hidden"
      >
        <TheMap
          :mapMarkers="newMapPlace"
          mapIcon="/map-marker.png"
          :mapCenter="newMapCenter"
          :mapZoom="12"
          :mapRadius="radius"
          @returned-map-place-clicked="updatePlace('newPlace', $event)"
          @returned-map-draggable="updatePlace('dragPlace', $event)"
          @returned-map-circle-clicked="updatePlace('circlePlace', $event)"
          :mapLat="lat"
          :mapLng="lng"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 fme-content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

const TheMap = () => import("@/components/fragment/map/TheMap");

export default {
  name: "ListHomePage",
  created() {
    this.changeVisitsPageOverview(false);
    this.changeMetricPage(false);
    this.changeReportPage(false);
    this.changeCrudPage(true);
    this.clearHistoryOverview();
  },
  updated() {
    this.changeCrudPage(true);
  },
  beforeDestroy() {},
  data() {
    return {};
  },
  components: {
    TheMap,
  },
  computed: {
    ...mapGetters("ModuleSupervision", [
      "crudPage",
      "crudCurrentPageTitle",
      "locationNameCrud",
      "locationAddressCrud",
      "locationLatitudeCrud",
      "locationLongitudeCrud",
      "locationGeolocationAdjustmentCrud",
      "locationRadiusCrud",
      "locationAutoFinishRadiusCrud",
    ]),
    lat() {
      return parseFloat(this.locationLatitudeCrud);
    },
    lng() {
      return parseFloat(this.locationLongitudeCrud);
    },
    radius() {
      return parseInt(this.locationRadiusCrud, 10);
    },
    autoFinishRadius() {
      return parseInt(this.locationAutoFinishRadiusCrud, 0);
    },
    newMapPlace() {
      let newPlace = [
        {
          position: {
            lat: this.lat,
            lng: this.lng,
          },
          radius: parseInt(this.locationRadiusCrud, 10),
          msg: this.locationNameCrud,
        },
      ];

      return newPlace;
    },
    newMapCenter() {
      let newCenter = {
        lat: this.lat,
        lng: this.lng,
      };

      return newCenter;
    },
  },
  methods: {
    ...mapActions("ModuleSupervision", [
      "changeCrudPage",
      "changeLocationLatitudeCrud",
      "changeLocationLongitudeCrud",
    ]),
    ...mapActions("ModuleOverview", [
      "changeVisitsPageOverview",
      "clearHistoryOverview",
    ]),
    ...mapActions("ModuleMetric", ["changeMetricPage"]),
    ...mapActions("ModuleReport", ["changeReportPage"]),
    updatePlace(refValue, eventValue) {
      if (refValue === "newPlace") {
        let latLng = {
          lat: eventValue.lat(),
          lng: eventValue.lng(),
        };

        this.changeLocationLatitudeCrud(latLng.lat);
        this.changeLocationLongitudeCrud(latLng.lng);
      } else if (refValue === "dragPlace") {
        this.changeLocationLatitudeCrud(eventValue.lat);
        this.changeLocationLongitudeCrud(eventValue.lng);
      } else if (refValue === "circlePlace") {
        this.changeLocationLatitudeCrud(eventValue.lat);
        this.changeLocationLongitudeCrud(eventValue.lng);
      }
    },
  },
  watch: {
    inputCurrentValue(newValue, oldValue) {
      if (this.inputDecimalNumber === true) {
        let newNumber;
        if (typeof newValue === "string") {
          newNumber = newValue.replace(/[a-zA-Z]/g, "");
        } else {
          newNumber = newValue;
        }

        this.inputValue = parseFloat(newNumber, 10);
      } else {
        this.inputValue = newValue;
      }
    },
  },
};
</script>

<style lang="scss">
.fme-new-edit__row {
  margin-top: 30px;
}
.fme-new-edit__row--last {
  margin-top: 50px;
  margin-bottom: 30px;
}
.fme-new-edit__title {
  padding-bottom: 50px;
  color: $fme-color__space-cadet;
  h3 {
    padding-top: 11px;
    padding-left: 12px;
    font-size: 24px;
    font-weight: 800;
  }
}
.fme-new-edit__buttons {
  button {
    margin-left: 12px;
  }
}
</style>
